// this should always be the same regardless of the environment
export const BASE_CANONICAL_URL = "https://mindtrip.ai"

// Retool's Places admin app; only shown to Mindtrip users, behind Retool auth
export const RETOOL_PLACES_URL =
  "https://mindtrip.retool.com/apps/4e94dd24-4224-11ef-9eb3-f3f4c30e1ce0/Places"
